"use client";

import { Button } from "@/components/ui/button";
import Link from "next/link";
import { Typography } from "@/components/ui/typography";
import type { AboutUsOurRootsProps } from "./types";
import { aboutUsOurRootsData } from "./constants";
import { memo } from "react";
import { cn } from "@/lib/utils";
import Image from "next/image";

const AboutUsOurRoots = ({ className }: AboutUsOurRootsProps) => {
  const { title, description, imageUrl, imageDimensions } = aboutUsOurRootsData;

  return (
    <section
      className={cn("section bg-background-secondary", className)}
    >
      <div className="container mx-auto py-12 lg:pt-20 lg:pb-16">
        <div className="grid grid-cols-1 gap-6 place-content-start md:grid-cols-2 md:gap-6 lg:grid-cols-[minmax(0,0.418fr)_minmax(0,0.581fr)] lg:gap-[min(3rem,3.33vw)]">
          <div className="flex">
            <div className="flex flex-auto min-w-0 md:p-6 md:rounded-xl md:bg-white md:border md:border-neutral-100">
              <div className="flex-auto min-w-0 rounded-2xl lg:rounded-lg overflow-hidden inline-flex aspect-[1/0.75] md:aspect-auto">
                <Image
                  src={imageUrl}
                  width={imageDimensions?.width}
                  height={imageDimensions?.height}
                  alt={title}
                  className="flex-auto min-w-0 object-top object-cover" 
                />
              </div>
            </div>
          </div>
          <div className="md:flex md:items-center">
            <div className="grid grid-cols-1 place-content-start gap-4 text-semantic-text-primary">
              <Typography variant="heading4" className="lg:text-gray-800">
                <h3>{title}</h3>
              </Typography>
              <div className="text-base leading-[163%] lg:text-gray-700 lg:leading-[150%] space-y-4 lg:space-y-6">
                {description?.map((text, i) => {
                  return <p key={i}>{text}</p>;
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(AboutUsOurRoots);
